export class Pagination {
  page: number = 0;
  content: any[] = [];
  more: boolean = true;
  pageSize: number = 10;
}